import React from 'react';

import styled from 'styled-components';

import { BackArrowLink } from 'components/navigation/back-arrow';
import AuthRequired from 'pages/authentication/auth-required';
import { routes } from 'utils/routing';

const Container = styled.div`
  display: flex;
  justify-content: center;

  ${Styles.desktop`
    padding: 8rem 0 1rem 0;
  `}
`;

const PaybackVendor = () => {
  return (
    <AuthRequired>
      <Container>
        <BackArrowLink to={routes.account} />
      </Container>
    </AuthRequired>
  );
};

export default PaybackVendor;
